var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39.349 423.724c-21.732 0-39.349-17.618-39.349-39.35v-256.747c0-21.733 17.618-39.351 39.351-39.351h433.299c21.733 0 39.351 17.618 39.351 39.351v256.778c0 21.715-17.603 39.318-39.318 39.318h-433.334z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.827 220.693h203.032c4.879 0 8.829-3.955 8.829-8.829v-114.759c0-4.879-3.95-8.829-8.829-8.829h-173.514c-21.178 0-38.345 17.168-38.345 38.345v85.243c0 4.874 3.955 8.829 8.827 8.829zm0 0",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.171 291.313h-203.036c-4.872 0-8.827 3.95-8.827 8.827v114.756c0 4.878 3.955 8.827 8.827 8.827h173.52c21.176 0 38.345-17.167 38.345-38.344v-85.24c0-4.876-3.955-8.826-8.829-8.826zm0 0",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.655 88.276h-173.52c-4.872 0-8.827 3.95-8.827 8.829v114.759c0 4.874 3.955 8.829 8.827 8.829h203.036c4.874 0 8.829-3.955 8.829-8.829v-85.243c0-21.177-17.169-38.345-38.345-38.345zm0 0",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.688 414.896v-114.756c0-4.877-3.95-8.827-8.829-8.827h-203.032c-4.872 0-8.827 3.95-8.827 8.827v85.24c0 21.176 17.167 38.344 38.345 38.344h173.514c4.879 0 8.829-3.95 8.829-8.828zm0 0",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.931 281.17s5.274 1.934 4.585 8.555l2.134-.044s-1.348-7.651-2.456-8.565c-1.113-.917-4.263.054-4.263.054zm0 0",
    fill: "#64b496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.215 280.151c-2.236 0-6.142-.005-10.259-1.114.917-.956 2.187-2.875 2.187-6.225 0-5.249-3.619-1.905-3.619-1.905s-2.377 2.003-.938 7.354c-1.406-.536-2.792-1.225-4.121-2.109.825-1.035 2.471-3.452 3.427-7.28 0 0-6.025-1.193-7.675 3.349-1.011-1.284-1.875-2.724-2.592-4.316 1.548.015 3.71-1.006 3.71-6.904 0 0-3.935.01-4.99 3.422-.415-1.431-.727-2.959-.961-4.575 1.571.459 5.634.786 5.634-8.032 0 0-4.877.01-6.005 4.331-.064-1.104-.089-2.246-.074-3.422 2.364-1.241 5.635-3.965 5.294-9.561 0 0-2.246.507-4.307 2.236.405-2.119.235-5.224-3.017-7.817 0 0-2.987 5.294 1.377 9.585-.381.538-.709 1.143-.981 1.816-.982-1.494-2.554-2.88-5.089-3.725 0 0-1.166 7.085 5.45 10.049.156 4.141.8 7.792 1.914 10.971-1.895-1.665-3.427-3.965-3.427-3.965 0-7.87-6.455-8.071-6.455-8.071-1.201 8.985 5.439 9.351 5.439 9.351l3.637 3.97c-7.871-1.314-7.871 5.244-7.871 5.244 5.25 1.314 7.871-1.309 7.871-1.309l2.842 1.455c-5.035.151-6.777 5.102-6.777 5.102 6.327 1.055 10.952-.434 12.529-1.055 6.372 4.454 14.224 4.459 17.852 4.459v-1.309zm0 0",
    fill: "#64b496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.77 280.151c2.236 0 6.147-.005 10.259-1.114-.917-.956-2.182-2.875-2.182-6.225 0-5.249 3.614-1.905 3.614-1.905s2.378 2.003.943 7.354c1.401-.536 2.792-1.225 4.121-2.109-.826-1.035-2.476-3.452-3.429-7.28 0 0 6.026-1.193 7.671 3.349 1.011-1.284 1.875-2.724 2.598-4.316-1.548.015-3.711-1.006-3.711-6.904 0 0 3.936.01 4.986 3.422.415-1.431.732-2.959.961-4.575-1.568.459-5.63.786-5.63-8.032 0 0 4.874.01 6.006 4.331.059-1.104.082-2.246.074-3.422-2.369-1.241-5.635-3.965-5.299-9.561 0 0 2.251.507 4.312 2.236-.406-2.119-.24-5.224 3.017-7.817 0 0 2.987 5.294-1.378 9.585.376.538.707 1.143.981 1.816.981-1.494 2.554-2.88 5.089-3.725 0 0 1.166 7.085-5.45 10.049-.156 4.141-.805 7.792-1.914 10.971 1.895-1.665 3.427-3.965 3.427-3.965 0-7.87 6.45-8.071 6.45-8.071 1.206 8.985-5.439 9.351-5.439 9.351l-3.637 3.97c7.87-1.314 7.87 5.244 7.87 5.244-5.244 1.314-7.87-1.309-7.87-1.309l-2.837 1.455c5.034.151 6.772 5.102 6.772 5.102-6.324 1.055-10.952-.434-12.525-1.055-6.371 4.454-14.222 4.459-17.851 4.459v-1.309zm0 0",
    fill: "#64b496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.861 222.953c-4.615 2.959-8.681 6.724-11.959 11.167 1.411 1.04 2.817 2.08 4.224 3.115 2.891-3.921 6.485-7.241 10.552-9.854zm0 0",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.014 257.064h18.365v10.499c0 2.895-2.349 5.249-5.244 5.249h-7.876c-2.154 0-4.047 1.055-5.245 2.661zm0 0",
    fill: "#ff6b71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.95 245.258v-14.434h19.677l-5.249 5.249v14.434h-14.428zm0 0",
    fill: "#5f64b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.821 250.502h6.557v6.557h-6.557z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.014 257.064h-18.369v10.499c0 2.895 2.349 5.249 5.249 5.249h7.871c2.159 0 4.052 1.055 5.249 2.661zm0 0",
    fill: "#ff6b71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.734 273.124c1.307.42 2.441 1.235 3.251 2.31h.059c.81-1.075 1.944-1.89 3.252-2.31v-10.811h-6.562zm0 0",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.079 245.258v-14.434h-19.682l5.249 5.249v14.434h14.434v-5.249zm0 0",
    fill: "#5f64b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.65 250.502h6.557v6.557h-6.557z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.208 237.387v3.936l3.936 2.621v-2.621zm0 0",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.144 241.323v3.935l5.244 2.627v-1.314zm0 0",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.821 237.387v3.936l-3.936 2.621v-2.621zm0 0",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.885 241.323v3.935l-5.249 2.627v-1.314zm0 0",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.93 266.249h-15.831c-3.594 0-6.512-2.935-6.512-6.557v-20.294l14.526 9.795 14.33-9.795v20.294c-.001 3.622-2.916 6.557-6.513 6.557zm0 0",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.83 242.636-5.249-3.935v14.429l5.249 2.626zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.199 242.636 5.244-3.935v14.429l-5.244 2.626zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.139 255.761h15.742v6.557h-15.742z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m248.144 243.944 7.87 3.941 7.871-3.941v11.811h-15.741zm0 0",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.917 245.184v13.194c0 1.084-.884 1.967-1.967 1.967h-7.871c-1.084 0-1.967-.884-1.967-1.967v-13.14l-3.936-2.631v15.771c0 3.257 2.647 5.904 5.904 5.904h7.871c3.256 0 5.904-2.646 5.904-5.904v-15.864zm0 0",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.29 254.349c-2.207.201-4.697.425-7.276 1.319-2.583-.894-5.067-1.117-7.28-1.319-3.696-.331-5.889-.654-7.147-2.885v3.789c1.927 1.255 4.375 1.485 6.914 1.714 2.28.2 4.639.415 7.05 1.329l.464.175.465-.175c2.411-.914 4.77-1.124 7.05-1.329 2.544-.229 4.99-.459 6.919-1.714v-3.799c-1.257 2.242-3.453 2.564-7.159 2.895zm0 0",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.636 241.977h-1.967v-1.967h-1.309v1.967h-1.972v1.314h1.972v5.902h1.309v-5.902h1.967zm0 0",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.08 236.747.723-.717 11.529 11.529-.723.717zm0 0",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.278 234.223 1.441 2.881 1.44-1.441zm0 0",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.624 234.761.825-.601 9.6 13.179-.825.6zm0 0",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.228 231.982.976 3.071 1.645-1.196zm0 0",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.926 239.252.581-.835 13.369 9.336-.585.835zm0 0",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.71 237.108 1.924 2.584 1.166-1.67zm0 0",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.416 248.266-.724-.717 11.529-11.529.723.719zm0 0",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.746 234.223-1.446 2.881-1.44-1.441zm0 0",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.805 247.924-.82-.601 9.6-13.179.825.601zm0 0",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.796 231.982-.976 3.071-1.65-1.196zm0 0",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.742 248.617-.581-.835 13.365-9.335.586.835zm0 0",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.309 237.108-1.919 2.584-1.166-1.67zm0 0",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.345 272.436s-5.072-5.449-4.086-10.449c.791-4.024 3.192-8.457 5.072-9.536 0 0 2.656-.166 1.987 2.144-.664 2.309-1.474 2.9-1.24 5.175.411 3.941 1.046 8.603-1.733 12.666zm0 0",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.889 252.479c-.317-.044-.562-.029-.562-.029-1.875 1.079-4.276 5.513-5.067 9.536-.45 2.275.361 4.639 1.371 6.542-.64-8.246 1.768-11.17 4.258-16.049zm0 0",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.079 259.774c-.234-2.275.576-2.871 1.24-5.18.469-1.616-.692-2.018-1.43-2.115 0 0-1.695 3.893-1.802 6.504-.098 2.295.489 11.641.264 13.457 2.773-4.067 2.138-8.729 1.728-12.666zm0 0",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.636 254.423c1.06-1.03 2.544-1.489 3.999-1.24-.687-2.222-1.381-4.444-2.07-6.665-1.455-.249-2.939.21-3.999 1.24.689 2.221 1.382 4.444 2.07 6.665zm0 0",
    fill: "#f5f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.635 253.183c1.06-1.03 2.545-1.495 4-1.245-.689-2.217-1.378-4.439-2.071-6.66-1.45-.25-2.939.21-3.999 1.24.689 2.221 1.383 4.443 2.07 6.665zm0 0",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.024 224.355c-7.125-.166-14.161 1.587-20.371 5.069-.855-1.524-1.714-3.051-2.569-4.575 7.031-3.945 14.995-5.927 23.056-5.742-.039 1.751-.082 3.5-.116 5.248zm0 0",
    fill: "#5f64b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.167 222.953c4.615 2.959 8.677 6.724 11.959 11.167-1.411 1.04-2.817 2.08-4.224 3.115-2.896-3.921-6.485-7.241-10.552-9.854zm0 0",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.005 224.355c7.125-.166 14.156 1.587 20.371 5.069.855-1.524 1.71-3.051 2.569-4.575-7.036-3.945-14.995-5.927-23.061-5.742.043 1.751.082 3.5.121 5.248zm0 0",
    fill: "#5f64b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.507 222.953c-6.87-1.88-14.121-1.88-20.991 0-.459-1.684-.922-3.374-1.381-5.059 7.772-2.129 15.981-2.129 23.759 0-.464 1.686-.923 3.376-1.387 5.059zm0 0",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.431 281.757c-5.664 1.48-11.201 3.476-16.529 5.986.747 1.582 1.49 3.164 2.236 4.746 5.142-2.421 10.489-4.336 15.957-5.742zm0 0",
    fill: "#ff6b71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.597 281.757c5.664 1.48 11.196 3.476 16.529 5.986-.747 1.582-1.495 3.164-2.237 4.746-5.141-2.421-10.487-4.336-15.961-5.742zm0 0",
    fill: "#ff6b71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.117 285.814c-13.799-3.31-28.184-3.31-41.982 0-.41-1.699-.815-3.402-1.225-5.102 14.604-3.505 29.829-3.505 44.434 0-.41 1.7-.817 3.403-1.227 5.102zm0 0",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.014 287.24-3.617.907c-.83.206-1.631-.419-1.631-1.274v-1.885c0-.854.801-1.479 1.631-1.274l3.617.902zm0 0",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.014 284.618 3.619-.908c.825-.205 1.631.42 1.631 1.274v1.89c0 .85-.806 1.48-1.631 1.27l-3.619-.904zm0 0",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.293 287.24h-.561c-.566 0-1.03-.459-1.03-1.03v-.562c0-.571.459-1.03 1.03-1.03h.561c.571 0 1.035.459 1.035 1.03v.562c-.006.572-.464 1.03-1.035 1.03zm0 0",
    fill: "#ff6b71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/do.6edc201ea4e8bf1938009bd2f6824af0.svg";
export { ForwardRef as ReactComponent };